import "./index.scss";
import classnames from "classnames";
import PropTypes from "prop-types";

import Icon from "common/core/icon";

export default function NotificationBar({ children, className, displayIcon, onCloseClick }) {
  const cx = classnames("notification-bar", className);

  return (
    <div className={cx}>
      {displayIcon && <Icon className="icon" name="doc-warning" />}
      {children}
      {onCloseClick && (
        <div className="notification-bar--close" onClick={onCloseClick}>
          <Icon name="x-small" />
        </div>
      )}
    </div>
  );
}

NotificationBar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  displayIcon: PropTypes.bool,
  onCloseClick: PropTypes.func,
};

NotificationBar.defaultProps = {
  displayIcon: true,
  onCloseClick: null,
};
